import type { ModalFuncProps } from 'ant-design-vue';
import type { ModalFunc } from 'ant-design-vue/es/modal/Modal';
import { confirm } from '~/features/modal';
import AntProvider from '~/features/provider/instance.vue';
import { CloseIconStandardClass } from '~/hooks/useModal/modals/closeIcon';

import { useShowPaymentEquity, useShowUpgradeEquity } from '@/features/paymentDesk/index';

import { CloseOutlined } from '@ant-design/icons-vue';

export const Wrapper = defineComponent({
  props: {
    source: String as PropType<SOURCE>,
  },
  setup(props, { slots }) {
    if (props.source) {
      provideResourceLocation({
        source: props.source,
      });
    }

    return () => slots.default?.();
  },
});

export const instances = new Map<string, ReturnType<ModalFunc>>();

export const clearModals = (name?: string) => {
  if (name) {
    instances.get(name)?.destroy();
    instances.delete(name);
    return;
  }
  useShowPaymentEquity().value = false;
  useShowUpgradeEquity().value = false;
  instances.forEach((modal, key) => {
    modal.destroy();
    instances.delete(key);
  });
};

export const useEmptyModal = (
  options: ModalFuncProps & { source?: SOURCE; name?: string },
  clear?: boolean,
) => {
  if (clear) {
    clearModals();
  }

  const rndStr = options.name || randomString(6);

  const modal = confirm({
    footer: false,
    icon: null,
    centered: true,
    wrapClassName: 'xmov-empty-modal',
    ...options,
    closeIcon: <CloseOutlined class={CloseIconStandardClass} />,
    content: () => (
      <AntProvider>
        <Wrapper source={options.source}>
          <options.content></options.content>
        </Wrapper>
      </AntProvider>
    ),
  });

  modal.then(res => {
    instances.set(rndStr, res);
    return res;
  });

  return {
    destroy: () => {
      return modal.then(res => {
        instances.delete(rndStr);
        res.destroy();
      });
    },
  };
};
